var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.4 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Door Bell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 26.1,
    r: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.8 6.8c-0.4 0-0.8-0.3-0.8-0.7-0.1-2.5 1-4.4 3.3-5.9 0.3-0.2 0.8-0.1 1 0.2s0.1 0.8-0.2 1c-1.8 1.2-2.7 2.7-2.6 4.6 0 0.4-0.3 0.8-0.7 0.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.6 6.8c-0.4 0-0.7-0.3-0.7-0.7-0.3-2.1-1.4-3.6-3.3-4.6-0.4-0.2-0.5-0.6-0.3-1s0.6-0.5 1-0.3c2.4 1.2 3.8 3.2 4.1 5.8 0 0.3-0.3 0.7-0.8 0.8 0.1 0 0 0 0 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m34.4 8.2h-7.4v-2.2l-12.3 2v-1c0-2.9-2.3-5.3-5.2-5.3s-5.2 2.4-5.2 5.3v2c0 0.9-0.3 1.8-1 2.4l-1.7 1.7c-0.9 1-1.4 2.2-1.4 3.5v2.4h5.7v0.3c0 1.4 0.7 2.7 1.8 3.4v21l19.3 4.2v-4.8h7.4v-34.9zm-32.7 9.2v-0.9c0-0.9 0.3-1.8 1-2.4l1.7-1.7c0.9-0.9 1.4-2.1 1.4-3.5v-1.9c0-2.1 1.7-3.8 3.7-3.8s3.7 1.7 3.7 3.8v2c0 1.3 0.5 2.5 1.4 3.5l1.7 1.7c0.6 0.6 1 1.5 1 2.4v0.9h-15.6zm5.7 1.9v-0.3h4.2v0.3c0 1.4-0.9 2.5-2.1 2.5s-2.1-1.2-2.1-2.5zm18.1 26.8l-16.3-3.6v-19.3h0.3c2 0 3.6-1.8 3.6-4v-0.3h5.7v-2.4c0-1.3-0.5-2.6-1.5-3.4l-1.7-1.7c-0.5-0.6-0.8-1.2-0.9-1.9l10.7-1.7v38.3zm7.4-4.5h-5.9v-31.9h5.9v31.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorbell);
export default __webpack_public_path__ + "static/media/doorbell.6226455e3446086983ec747aa8eb2d54.svg";
export { ForwardRef as ReactComponent };